import React from 'react';

import PageLayout from '../../../components/PageLayout';

import Shadower from './Shadower';

async function action() {
  return {
    title: 'Shadower',
    description: 'Shadower - Skill shadowing in real life',
    chunks: ['shadower'],
    component: (
      <PageLayout>
        <Shadower />
      </PageLayout>
    ),
  };
}

export default action;
